import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { acctAlerts } from "../../api/accounting";
import { Money } from "./Money";
import { Card3D } from "./Card3D";

const TONE = {
  high:   "border-rose-500/40 bg-rose-500/8 text-rose-500",
  medium: "border-amber-500/40 bg-amber-500/8 text-amber-600",
  low:    "border-border/60 bg-background/50 text-muted-foreground",
};

export const AlertList = () => {
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState([]);

  useEffect(() => { acctAlerts().then(setAlerts).catch(() => setAlerts([])); }, []);
  if (alerts.length === 0) return null;

  return (
    <Card3D titleKey="acct.alerts" testid="acct-alerts"
            headerRight={<AlertTriangle className="h-5 w-5 text-amber-500 drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]" />}>
      <div className="grid gap-2">
        {alerts.map((alert, index) => (
          <a key={index} href={alert.link}
             data-testid={`alert-${alert.kind}-${index}`}
             className={`flex items-center justify-between gap-3 rounded-2xl border px-3 py-2.5 text-xs font-semibold transition
                          hover:-translate-y-0.5 ${TONE[alert.severity]}`}>
            <span className="font-black">{t(`acct.alertKind.${alert.kind}`)}</span>
            <span className="min-w-0 flex-1 truncate text-muted-foreground">{alert.reference}</span>
            {alert.amount ? <Money value={alert.amount} currency={alert.currency} /> : null}
          </a>
        ))}
      </div>
    </Card3D>
  );
};
